module.exports = __webpack_public_path__ + "img/faq.2a1eef73.svg";